import React from 'react';
import { ReadItem } from '../../../../read-page/read-category';

const ReadLists = ({ allReads }) => {
  return (
    <div className="">
      <section className="category-container  bg-dark pd-t-0 pd-b-half">
        <div className="wrapper  ">
          <div className="cat_watch-list">
            <div className="cat_watch-row bible">
              <div className="cat_watch-body">
                <div className="cat_watch-body-list">
                  <div className="cat_watch-item">
                    <div className="watch_item-row columns-5  d-flex">
                      {!!allReads?.nodes &&
                        allReads?.nodes?.map((read, index) => (
                          <ReadItem key={index} read={{ ...read.data, url: read.url }} />
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ReadLists;
